import { render } from "./decisions.vue?vue&type=template&id=0f6f161f"
import script from "./decisions.vue?vue&type=script&lang=ts"
export * from "./decisions.vue?vue&type=script&lang=ts"

import "./decisions.vue?vue&type=style&index=0&id=0f6f161f&lang=scss"
script.render = render

export default script